






































import Vue from 'vue'
import Card from '@/components/Card.vue'
import CurrencyDialog from '@/components/Settings/CurrencyDialog.vue'
import AddButton from '@/components/AddButton.vue'
import { Exchange } from '@/utils/interfaces'
import CountryFlag from 'vue-country-flag'

export default Vue.extend({
  components: {
    appCard: Card,
    appCurrencyDialog: CurrencyDialog,
    appAddButton: AddButton,
    appCountryFlag: CountryFlag,
  },
  data() {
    return {
      dialogModel: false,
      editedExchange: null as null | Exchange,
      editedIndex: -1,
      items: [
        {
          from: {
            currency: 'USD',
            amount: 1,
            flag: 'US',
          },
          to: {
            currency: 'CUP',
            amount: 27,
            flag: 'CU',
          },
        },
      ] as Exchange[],
    }
  },
  methods: {
    newExchange() {
      this.editedIndex = -1
      this.editedExchange = null
      this.dialogModel = true
    },
    editExchange(item: Exchange) {
      this.editedExchange = item
      this.editedIndex = this.items.indexOf(item)
      this.dialogModel = true
    },
    onNewExchange(payload: Exchange) {
      if (this.editedIndex !== -1) {
        this.items.splice(this.editedIndex, 1, payload)
      } else this.items.push(payload)
    },
  },
})
